module.exports = __webpack_public_path__ + "logo_socar-356c51ccc25589a4d71323cec6696637.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo_socar.png
// module id = 1379
// module chunks = 1